module.exports = __webpack_public_path__ + "img/church_thumbnail-600x450.b7ae7900.jpg";